import React from 'react';
import Logo from '../Logo';
import PifLogo from '../PifLogo';
import LexusLogo from '../LexusLogo';
import RolexLogo from '../RolexLogo';

/** Sponsor bucket → logo component */
export const SPONSOR_LOGOS = {
  'Tournament Logo': null,
  'PIF': <PifLogo />,
  'Lexus': <LexusLogo />,
  'Rolex': <RolexLogo />,
};

/** Map EventTemplate (lowercase) to display label.
 *  ONLY these known sponsors produce a metric card.
 *  Rows that don't match are excluded entirely. */
export const KNOWN_SPONSORS = {
  tournamentsponsor: 'Tournament Logo',
  pif: 'PIF',
  lexus: 'Lexus',
  rolex: 'Rolex',
  ibm: 'IBM',
};
